import React from 'react';

import { useSection } from './hooks/use-context';
import { Signatures } from './signatures';

export const Table: React.FC = () => {
  const { questions } = useSection();

  const containerStyle: React.CSSProperties = {
    fontFamily: 'Arial, sans-serif',
    fontSize: '10px',
    backgroundColor: '#E0F4E9',
    padding: '10px',
    marginBottom: '20px',
  };

  const tableStyle: React.CSSProperties = {
    width: '100%',
    borderCollapse: 'collapse',
    backgroundColor: '#FFFFFF',
  };

  const thTdStyle: React.CSSProperties = {
    padding: '4px',
    textAlign: 'left',
    verticalAlign: 'top',
  };

  const headerCellCenterStyle: React.CSSProperties = {
    ...thTdStyle,
    textAlign: 'center',
  };

  const checkboxStyle: React.CSSProperties = {
    display: 'inline-block',
    width: '16px',
    height: '16px',
    border: '1px solid #000',
    margin: 'auto',
    textAlign: 'center',
  };

  const numberedQuestions = questions.filter(
    (q) =>
      /^\d+\.\s/.test(q.name) &&
      q.answers.every((answer) => !answer.question_parent_option_id),
  );

  return (
    <div style={containerStyle}>
      <table style={tableStyle}>
        <thead style={{ backgroundColor: '#D9D9D9' }}>
          <tr
            style={{
              borderTop: '1px solid #D9D9D9',
              borderLeft: '1px solid #D9D9D9',
              borderRight: '1px solid #D9D9D9',
              borderRadius: '6px',
            }}
          >
            <th style={{ ...thTdStyle, width: '30px' }}>Nº</th>
            <th style={{ ...thTdStyle }}>Perguntas</th>
            <th style={headerCellCenterStyle}>Sim</th>
            <th style={headerCellCenterStyle}>Não</th>
            <th style={headerCellCenterStyle}>F</th>
            <th style={headerCellCenterStyle}>A</th>
            <th style={headerCellCenterStyle}>P</th>
            <th style={headerCellCenterStyle}>S</th>
          </tr>
        </thead>
        <tbody style={{ border: '1px solid #000' }}>
          {numberedQuestions.map((question, index) => {
            const match = question.name.match(/^(\d+)\.\s(.+)/);
            const questionChildren = questions.filter((q) =>
              q.answers.every(
                (answer) =>
                  answer.question_parent_option_id ===
                  question.answers?.[0].content,
              ),
            );

            return (
              <>
                <tr key={index} style={{breakInside: 'avoid'}}>
                  <td
                    style={{
                      ...headerCellCenterStyle,
                      border: '1px solid #000',
                    }}
                  >
                    {parseInt(match?.[1] || `${index}`, 10)}
                  </td>
                  <td style={{ ...thTdStyle, border: '1px solid #000' }}>
                    {match?.[2] || question.name}
                  </td>
                  <td
                    style={{
                      ...headerCellCenterStyle,
                      border: '1px solid #000',
                    }}
                  >
                    <div style={checkboxStyle}>
                      {question.answers?.[0].option === 'Sim' ? 'X' : ''}
                    </div>
                  </td>
                  <td
                    style={{
                      ...headerCellCenterStyle,
                      border: '1px solid #000',
                    }}
                  >
                    <div style={checkboxStyle}>
                      {question.answers?.[0].option === 'Não' ? 'X' : ''}
                    </div>
                  </td>
                  {[...Array(4)].map((_, i) => (
                    <td
                      key={i}
                      style={{
                        ...headerCellCenterStyle,
                        border: '1px solid #000',
                      }}
                    >
                      <div style={checkboxStyle}>
                        {questionChildren?.filter(
                          (question) => question.type === 'checkbox',
                        )?.[0]?.answers?.[0]?.option === ['F', 'A', 'P', 'S'][i]
                          ? 'X'
                          : ''}
                      </div>
                    </td>
                  ))}
                </tr>
                <tr key={`2_${index}`} style={{breakInside: 'avoid'}}>
                  <td
                    style={{
                      ...headerCellCenterStyle,
                      border: '1px solid #000',
                    }}
                  ></td>
                  <td
                    style={{
                      ...thTdStyle,
                      height: '25px',
                      backgroundColor: '#F0F0F0',
                    }}
                  >
                    {
                      questionChildren.findLast(
                        (question) => question.type === 'text',
                      )?.answers?.[0]?.content
                    }
                  </td>
                  {[...Array(6)].map((_, i) => (
                    <td
                      key={i}
                      style={{
                        ...headerCellCenterStyle,
                        backgroundColor: '#F0F0F0',
                      }}
                    ></td>
                  ))}
                </tr>
              </>
            );
          })}
        </tbody>
      </table>

      <div
        style={{
          backgroundColor: '#FFFFFF',
          padding: '10px',
          marginBottom: '20px',
          border: '1px solid #000',
          borderTop: 'none',
          minHeight: '120px',
          width: '100%',
        }}
      >
        <p
          style={{
            fontSize: '10px',
            marginBottom: '8px',
          }}
        >
          Obs: Em caso de elaboração de LAAI para alterações / mudanças nos
          setores ou equipamentos, utilizar o FORMU-0607 Planejamento de
          Mudanças.
        </p>
        <div
          style={{
            backgroundColor: '#FAE0CD',
            textAlign: 'center',
            padding: '4px',
            marginBottom: '10px',
            border: '1px solid #69CC8D',
            borderRadius: '5px',
          }}
        >
          REGISTRO FOTOGRÁFICO
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: '1rem',
            padding: '1rem',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {questions
            .find(
              (question) =>
                question.question_id === 'ed37653d-056c-4f33-87cd-be728d06ff5e',
            )
            ?.answers.map((answer, index) => (
              <div
                key={`${answer.id}-${index}`}
                style={{
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <img
                  style={{
                    objectFit: 'contain',
                    width: '100%',
                    height: '100%',
                    maxHeight: '300px',
                  }}
                  src={`${answer.content || ''}`}
                  alt="img"
                />
              </div>
            ))}
        </div>
      </div>

      <Signatures />
    </div>
  );
};
